// CardActions — fila de acciones secundarias de una card ("[Editar] [Vendedores] [Inventario]…"
// de los mocks M6). Links de texto pequeños (no botones sólidos, según la ficha B01). Cada acción
// ejecuta (onClick), se deshabilita (disabled) o se oculta (hidden — útil para gating por rol).
import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';

export interface CardAction {
    label: string;
    onClick?: () => void;
    disabled?: boolean;
    hidden?: boolean;
    icon?: ReactNode;
}

export interface CardActionsProps {
    actions: CardAction[];
    className?: string;
}

export function CardActions({ actions, className }: CardActionsProps) {
    const visible = actions.filter((a) => !a.hidden);
    if (visible.length === 0) return null;
    return (
        <div className={cn('flex flex-wrap items-center gap-x-4 gap-y-1', className)}>
            {visible.map((a) => (
                <button
                    key={a.label}
                    type="button"
                    disabled={a.disabled}
                    onClick={a.onClick}
                    className="inline-flex items-center gap-1 text-[12px] font-medium text-primary transition-colors hover:text-primary/80 disabled:cursor-not-allowed disabled:opacity-40"
                >
                    {a.icon}
                    {a.label}
                </button>
            ))}
        </div>
    );
}
